// src/views/components/Motion/ScrollReveal.jsx
import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const getVariants = (direction, distance, scale, blur) => {
  let initialTransform = { opacity: 0 };

  if (direction === 'up') initialTransform.y = distance;
  else if (direction === 'down') initialTransform.y = -distance;
  else if (direction === 'left') initialTransform.x = distance;
  else if (direction === 'right') initialTransform.x = -distance;

  if (scale) initialTransform.scale = 0.92;
  if (blur) initialTransform.filter = 'blur(8px)';

  return {
    hidden: initialTransform,
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      filter: 'blur(0px)',
      transition: {
        duration: 0.6,
        ease: [0.215, 0.61, 0.355, 1], // Smooth cubic bezier curve
      },
    },
  };
};

const ScrollReveal = ({
  children,
  direction = 'up',
  distance = 30,
  delay = 0,
  duration = 0.6,
  scale = false,
  blur = true,
  once = true,
  amount = 0.15,
  className = '',
  style = {},
  onClick,
}) => {
  const shouldReduceMotion = useReducedMotion();

  if (shouldReduceMotion) {
    return <div className={className} style={style} onClick={onClick}>{children}</div>;
  }

  const variants = getVariants(direction, distance, scale, blur);

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
      variants={variants}
      transition={{ delay, duration }}
      className={className}
      style={{ willChange: 'transform, opacity, filter', ...style }}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
